import React from 'react';
import { useTranslations } from '@lang';
import {
  CloseModalButton,
  Header as ModalHeader,
  MobileHeading,
  Modal,
  PrevStepButton,
} from '@common/components/BookingForms';
import SectionContainer from '@common/components/SectionContainer';
import { Heading4, Text } from '@common/components/Typography';
import {
  HeaderWrapper,
  StyledFormWrapper,
  StyledInnerScroller,
} from './PersonalisationModal.styles';
import { FulfilableBasketItemType } from '../../FulfilableAddedToBasket.types';

type PersonalisationModalProps = {
  title: string;
  active: boolean;
  close: () => void;
  type: FulfilableBasketItemType;
  children: React.ReactNode;
};

export function PersonalisationModal({
  title,
  active,
  close,
  type,
  children,
}: PersonalisationModalProps) {
  const { t } = useTranslations();

  return (
    <Modal isVisible={active}>
      <>
        <ModalHeader data-cy="modal-header">
          <PrevStepButton onClick={close} data-testid="backButton" />
          <MobileHeading>{title}</MobileHeading>
          <CloseModalButton onClick={close} data-testid="closeButton" />
        </ModalHeader>
        <StyledInnerScroller>
          <StyledFormWrapper>
            <SectionContainer>
              <HeaderWrapper>
                <Heading4 data-cy="personalise-header" tag="h1">
                  {t('personalization.PersonaliseHeader')}
                </Heading4>
                <Text isSmall data-testid="subheader">
                  {type === 'voucher' && t('personalization.PersonaliseSubheaderVoucher')}
                  {type === 'event' && t('personalization.PersonaliseSubheaderEvent')}
                </Text>
              </HeaderWrapper>
              {children}
            </SectionContainer>
          </StyledFormWrapper>
        </StyledInnerScroller>
      </>
    </Modal>
  );
}
